import { render, staticRenderFns } from "./Aneel15.vue?vue&type=template&id=0fa292e4&"
import script from "./Aneel15.vue?vue&type=script&lang=js&"
export * from "./Aneel15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports